import CotizacionEnviarProvider from '../providers/cotizacionEnviar-provider';
import TokenProvider from '../../commons/providers/token-provider';

class CotizacionEnviarRepository {
  constructor() {
    this.cotizacionEnviarProvider = new CotizacionEnviarProvider();
    this.tokenProvider = new TokenProvider();
  }

  postCotizacionEnviar = async (datosEnvia) => {
    await this.tokenProvider.getToken();
    return this.cotizacionEnviarProvider.postCotizacionEnviar(datosEnvia);
  };
}

export default CotizacionEnviarRepository;
